/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Campaigns',
    CERTIFICATES: 'Certificates',
    CHALLENGES: 'Challenges',
    CHAT: 'Chat',
    CLOSE: 'Close',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Commissioned products',
    COMMUNICATIONS: 'Communications',
    CONFIRM: 'Confirm',
    COUNTERPART: 'Counterparts',
    DASHBOARD: 'Dashboard',
    DESIGN_REQUESTS: 'Design requests',
    DETAILS: 'Details',
    EXTERNAL_APPLICATIONS: 'External Applications',
    FOLLOWER_MESSAGES: 'Follower messages',
    GENERICS: 'Generics',
    LINKS: 'Links',
    LIVE: 'live',
    LOGOUT: 'Logout',
    MEMBERS: 'Members',
    MENTIONS: 'Mentions',
    OFFERS: 'Offers',
    ON_DEMAND_CAMPAIGNS: 'On demand campaigns',
    OPPORTUNITIES: 'Opportunities',
    ORDERS: 'Paid Orders',
    PARTNERS: 'Partners',
    PERSONAL_AREA: 'Personal area',
    PRODUCTS_OFFERED: 'Products offered',
    PROFILE: 'Profile',
    PROZIS_COMMUNITY: 'Prozis Community',
    QUESTIONS: 'Questions',
    REMUNERATIONS: 'Remunerations',
    SELECT_LANGUAGE: 'Select language',
    SELECT_PARTNER: 'Select another partner',
    SERVICES: 'Services',
    SOCIAL_NETWORK: 'Prozis social network',
    STATISTICS: 'Statistics',
    VIDEO_TUTORIALS: 'Video tutorials'
  },
  ERROR: {
    ERROR: 'Error',
    FETCH_DATA: 'Fetch data'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Campaigns',
    CHALLENGES: 'Challenges',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Communications',
    COUNTERPARTS: 'Counterparts',
    DASHBOARD: 'Dashboard',
    DESIGN_REQUESTS: 'Design requests',
    DETAILS: 'Details',
    EXTERNAL_APPLICATIONS: 'External Applications',
    FILTER: 'Filter',
    FILTERED: 'Filtered',
    FOLLOWER_MESSAGES: 'Follower messages',
    GENERICS: 'Generics',
    HOME: 'Home',
    LINKS: 'Links',
    LOGOUT: 'Logout',
    MEMBERS: 'Members',
    MENTIONS: 'Instagram mentions',
    NOT_FOUND: '404, Are you lost?',
    OFFERS: 'Offers',
    ORDERS: 'Orders',
    PARTNERSHIP_NOT_FOUND: 'No partnership found.',
    PENDING_COUNTERPART: 'Previous period\'s pending counterparts',
    PENDING_COUNTERPART_CURRENT: 'Current month\'s pending counterparts',
    PENDING_REMUNERATION: 'Previous period pending remunerations',
    PENDING_REMUNERATION_CURRENT: 'Current month pending remunerations',
    PERSONAL_AREA: 'Personal area',
    PRODUCTS: 'Products',
    REMUNERATIONS: 'Remunerations',
    SEARCH_PARTNERSHIP: 'Search a partnership',
    SELECT_LANGUAGE: 'Select language',
    SELECT_PARTNERSHIP: 'Select a partnership',
    UNAUTHROZIED: '403, Unauthorized access!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
